import { Badge } from "@/shared/components/ui/badge";
import { LayoutTemplate } from "lucide-react";
import type { TemplateOrigin } from "../../../queries/reports";

export function TemplateOriginLink({
  origin,
  iconOnly = false,
}: {
  origin: TemplateOrigin;
  iconOnly?: boolean;
}) {
  return (
    <Badge
      asChild
      variant="outline"
      className={iconOnly ? "px-1.5 font-normal" : "font-normal"}
    >
      <a
        href={origin.href}
        target="_blank"
        rel="noreferrer"
        aria-label={iconOnly ? origin.name : undefined}
        title={iconOnly ? origin.name : undefined}
      >
        <LayoutTemplate aria-hidden="true" />
        {!iconOnly && origin.name}
      </a>
    </Badge>
  );
}
